export default {

  categories () {
    return [
      {
        id: 0,
        name: 'All',
        color: ''
      },
      {
        id: 3,
        name: "Fran's Picks",
        color: 'pink'
      },
      {
        id: 1,
        name: 'Life',
        color: '#ec87f4'
      },
      {
        id: 2,
        name: 'Work',
        color: '#6fff6f'
      }
    ]
  },

  spaces () {
    return [
      {
        name: 'Personal Dashboard',
        id: 'I4x2de1LCW2P25d_21Tsy',
        categoryId: 1
      },
      {
        name: 'Project & Issue Tracker',
        id: 'p56fqtZUlNtFJ6td-uovI',
        categoryId: 2
      },
      {
        name: 'Roadmap',
        id: 'J4vbhO646y4296cLRQEU3',
        categoryId: 2
      },
      {
        name: 'Org Chart',
        id: 'HubC-58kjXefGBfyCRohk',
        categoryId: 2
      },
      {
        name: 'Moodboard',
        id: 'GgDOqKvEEzTA93EYmAZrn',
        categoryId: 2
      },
      {
        name: 'Weekly Planner',
        id: 'tZgYERhi-QFX2LmlVNOAb',
        categoryId: 1
      },
      {
        name: 'Calendar',
        id: 'fqSeePL0oeocZfcg6y1w5',
        categoryId: 1
      },
      {
        name: '2×2 Matrix',
        id: '7g5WGAAgha0ovyOJIXC1Q',
        categoryId: 2
      },
      {
        name: 'Business Plan',
        id: '286llONI_DEmGoIa1sCtj',
        categoryId: 2
      },
      {
        name: 'Time Tracking',
        id: '-ou2kHxO40-rDFZymIn1A',
        categoryId: 2
      },

      {
        name: 'Monthly Blog Space',
        id: 'v-84fZYmEXgTK9FjAv3UO',
        categoryId: 3
      },
      {
        name: 'Digital Birthday Card',
        id: 'E4GkMuiG9X_sVHt2F3akd',
        categoryId: 3
      },
      {
        name: 'My Monthly Space',
        id: 'JHDr598KhqoI1FU9ZzrDQ',
        categoryId: 3
      }
    ]
  },
  developmentSpaces () {
    return []
  }
  // {
  //   name: 'Software Architecture'
  //   id: '1t4616FBkaJOxMdrt9O_p',
  //   categoryId: 2,
  // },
  // {
  //   name: 'Database Schema'
  //   id: 'WSzpRkVqSdv8GKCSCrwrg',
  //   categoryId: 2,
  // },

  // 🚑 missing templates: Note Taking, Research, Journal, Making Hard Decisions, Mind Map, Weekly Planner,
  // 102293910caf3bbc3cdee8f07dd5e720ffd4e6e9

  // Moodboarding
  // Note taking
  // Research
  // Presentations
  // Visual thinking

  // {
  //   id: '123',
  //   categoryId: 4,
  //   name: 'Retrospective'
  // }
  //   ]
  // }

}
